export default function getSplicedList(list, item, options = {}) {
  const opts = { key: 'id', exchange: true, ...options };

  if (!list) return list;

  const nextList = [...list];
  // Integer ID, String UUID 혼용으로 인해서 == 사용
  // eslint-disable-next-line eqeqeq
  const idx = nextList.findIndex((o) => o[opts.key] == item[opts.key]);
  if (idx !== -1) {
    nextList.splice(idx, 1);
  }
  if (opts.exchange) {
    return [item, ...nextList];
  }
  return nextList;
}
